import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="project-unit-form"
export default class extends Controller {
  static targets = [
    "templateType",
    "quantityUnit",
    "storageUnit",
    "displayUnit",
    "billingUnit",
  ];

  static values = {
    unitLabels: Object,
  };

  connect() {
    this.refreshUnitHints();
  }

  refreshUnitHints() {
    const templateType = this.hasTemplateTypeTarget
      ? this.templateTypeTarget.value
      : "";
    const quantityUnit = this.hasQuantityUnitTarget
      ? this.quantityUnitTarget.value
      : "";

    const storageUnit =
      templateType === "audio" || templateType === "video"
        ? "second"
        : quantityUnit || "piece";
    const displayUnit =
      templateType === "audio"
        ? "minute"
        : templateType === "video"
          ? "second"
          : storageUnit;
    const billingUnit =
      templateType === "audio"
        ? "hour"
        : templateType === "video"
          ? "piece"
          : displayUnit;

    this.storageUnitTarget.textContent = this.unitLabelFor(storageUnit);
    this.displayUnitTarget.textContent = this.unitLabelFor(displayUnit);
    this.billingUnitTarget.textContent = this.unitLabelFor(billingUnit);
  }

  unitLabelFor(unit) {
    return this.unitLabelsValue?.[unit] || unit;
  }
}
